import JSON from "../json/countries.json"
const countries = JSON;
export default countries